module.exports = "dist/8b43027f47b20503057dfbbaa9401fef.eot";